import LogoVipIt from '../../src/legacy/LogoVipIt';
export default LogoVipIt;
